"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewUsersPopover = void 0;
const React = __importStar(require("react"));
const antd_1 = require("antd");
const AbstractHelpPopover_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/help/AbstractHelpPopover");
const NewUsersPopover = () => {
    const content = React.createElement("div", { style: { width: "400px" } },
        React.createElement("p", null,
            "Users are counted as \u201Cnew\u201D, when Usergeek sees their ",
            React.createElement(antd_1.Typography.Text, { code: true }, "Principal"),
            " for the first time ever."),
        React.createElement("p", null, "That\u2019s why, if Usergeek is integrated into already launched project, some time is needed to adjust the data (e.g. in the 1st day all users are new from the Usergeek\u2019s perspective)."));
    return React.createElement(AbstractHelpPopover_1.AbstractHelpPopover, { title: "New users", content: content });
};
exports.NewUsersPopover = NewUsersPopover;
